import React from 'react';
import Styles from './signup-header-styles.scss';
import { useNavigate } from 'react-router';
import { ButtonKVBase } from '@/presentation/components';
import LogoAuth2 from '../logo/logoAuth2';
import { isMobile } from 'mobile-device-detect';
import AuthHeaderPartner from '../auth-header/auth-header-partner';
const SignUpHeader = ({ hideSignInButton = false }) => {
    const navigate = useNavigate();
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        navigate('login');
    };
    return (React.createElement("header", { className: Styles.headerWrap },
        React.createElement("div", { className: Styles.logo },
            React.createElement(LogoAuth2, null)),
        React.createElement("div", { style: { marginRight: 'auto' } },
            React.createElement(AuthHeaderPartner, { headerSignUp: true })),
        !hideSignInButton && (React.createElement("div", { className: Styles.headerRight },
            React.createElement("div", { className: Styles.text }, "Already have an account?"),
            React.createElement("div", null,
                React.createElement(ButtonKVBase, { type: 'button', onClick: handleClick, className: Styles.submitButton, btnBackgroundGradient: !isMobile
                        ? 'linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)'
                        : 'linear-gradient(90deg, rgba(255, 168, 0, 1) 0%, rgba(127, 27, 255, 1) 100%)' }, "Sign In"))))));
};
export default SignUpHeader;
